/**
 * A person's display name from their Supabase auth user, derived the way
 * `users-provision` derives it (`metadata.display_name ?? metadata.name ??
 * email local part`) so the household the fork creates (YAR-438) is named
 * exactly as the one provisioning used to create at sign-in.
 *
 * `user_metadata` is provider-written and can be blank; the email local part
 * is the fallback provisioning uses, and "Family" is the floor so the name is
 * never an empty string.
 */
export function displayNameFromUser(
  user:
    | { email?: string | null; user_metadata?: Record<string, unknown> | null }
    | null
    | undefined,
): string {
  const meta = user?.user_metadata ?? {};
  const candidates = [meta.display_name, meta.name, user?.email?.split('@')[0]];
  for (const c of candidates) {
    if (typeof c === 'string' && c.trim()) return c.trim();
  }
  return 'Family';
}
